import React from "react";
import { Route, Routes } from "react-router-dom";
import SelfService from "./Component/Self-Service/SelfService";
import Login from "./Component/Self-Service/Login";
import CompanyTickets from "./Component/Self-Service/CompanyTickets";

const PageRouter = () => {
  return (
    <Routes>
      <Route path="" element={<Login />} />
      <Route path="/Self-Service" element={<SelfService />} />
      <Route path="/Self-Service/Company-Tickets" element={<CompanyTickets />} />
      <Route path="/Self-Service/Company-Tickets/:customerId" element={<CompanyTickets />} />
    </Routes>
  );
};

export default PageRouter;
